import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { PhotowallService } from 'src/app/core/services/photowall.service';
import { environment } from 'src/environments/environment';
import { createS3Client, createCognitoCredentials, createUpload, loadS3ClientModule } from '../../utils/aws-s3.util';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
  selector: 'app-sponsor-details',
  templateUrl: './sponsor-details.component.html',
  styleUrls: ['./sponsor-details.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class SponsorDetailsComponent implements OnInit {

  sponsors: any[] = [];
  newSponsorName: string = '';
  newSponsorImages: File[] = [];
  showMessage: any = '';
  //private s3: AWS.S3;
  selectedFiles: File[] = [];
  newSponsorImageFrequency: number | null = 7;
  editMode: boolean = false;
  selectedFileNames: string[] = [];
  sponsorList: any[] = [];
  tempData: any;
  nameExists: boolean = false;
  showSponsors: boolean = false;
  fileTypeError: boolean = false;
  disableButton: boolean = true;
  isPopupOpen: boolean = false;
  isSavingData: boolean = false;
  editIndex: any;
 private identityPoolId: string = environment.aws.IdentityPoolId;
  constructor(private fb: FormBuilder, private photoService: PhotowallService,
    private router: Router, public fbAuth: AngularFireAuth) {
    //aws

  }


  async ngOnInit(): Promise<void> {
    this.isSavingData = true;
    (await this.photoService.getSponsorData(localStorage.getItem('e'))).subscribe({
      next: (res) => {
        // console.log(res); //__CONSOLE_LOG__
        let response: any;
        response = res;
        if (res.result != "Sponsors not available!") {
          response.sponsors.forEach((element: {
            files: any;
            imageUrls: any;
            id: any; sponsor_name: any; frequency: any;
          }) => {
            this.sponsors.push({
              name: element.sponsor_name,
              id: element.id,
              images: [...element.imageUrls],
              imageFrequency: element.frequency,
              fileNames: element.files
            });
            this.sponsorList = this.sponsors;

          });
        }
        this.showSponsors = res.show_sponsors;
        this.isSavingData = false;
      }
    });



  }

  onToggleChange(event: any) {
    if (!event.checked) {  // If the toggle is switched off
      // console.log(this.showSponsors); //__CONSOLE_LOG__

      this.saveSponsor();
    }
  }

  openAddSponsorPopup(): void {
    // Reset form fields
    this.newSponsorName = '';
    this.newSponsorImageFrequency = null;
    this.newSponsorImages = [];
    this.nameExists = false;
    this.fileTypeError = false;
    this.isPopupOpen = true;
    this.editMode = false;
  }

  closePopup(): void {
    this.isPopupOpen = false;
  }

  checkNameExists(name: string) {
    this.nameExists = this.sponsors.some(sponsor => sponsor.name.toLowerCase() === name.toLowerCase());
  }


  async saveSponsor() {
    this.isSavingData = true;
    // console.log(this.sponsorList);
    // console.log(this.newSponsorName); //__CONSOLE_LOG__
    if ((this.newSponsorName && this.newSponsorImages.length) || this.showSponsors == true) {
      if (this.newSponsorName != null && this.newSponsorName != "") {
        if (this.editMode == true) {
          this.sponsors.splice(this.editIndex, 0, {
            name: this.newSponsorName,
            images: [...this.newSponsorImages],
            imageFrequency: this.newSponsorImageFrequency
          });
        }
        else {
          this.sponsors.push({
            name: this.newSponsorName,
            images: [...this.newSponsorImages],
            imageFrequency: this.newSponsorImageFrequency
          });
        }

      }


      (await this.photoService.saveSponsorData(localStorage.getItem('e'), this.newSponsorName, this.newSponsorImageFrequency, this.selectedFileNames, this.showSponsors)).subscribe({
        next: async (res) => {
          // console.log(res); //__CONSOLE_LOG__
          let response: any;
          response = res;
          this.showMessage = response['result'];
          let sponsor_id = response['sponsor_id'];
          if (sponsor_id) {
            // console.log(sponsor_id); //__CONSOLE_LOG__

            this.deleteFolderContents(localStorage.getItem('e'), sponsor_id);

            for (let i = 0; i < this.selectedFiles.length; i++) {
              const updatedFileName = this.selectedFiles[i].name.replace(/\s+/g, '_');
              const renamedFile = new File([this.selectedFiles[i]], updatedFileName, { type: this.selectedFiles[i].type });

              await this.uploadFile(localStorage.getItem('e'), renamedFile, sponsor_id)
                .then(async (data) => {
                  // console.log("File uploaded successfully:", data); //__CONSOLE_LOG__
                  this.showMessage = "File uploaded successfully!"
                })
                .catch((error) => {
                  // console.error("Error uploading file:", error); //__CONSOLE_LOG__
                  this.showMessage = "Error uploading file!"
                });
            }
            this.selectedFileNames = [];
          }
          this.isSavingData = false;
        }
      });
      this.newSponsorName = '';
      this.newSponsorImages = [];
      this.newSponsorImageFrequency = null;
      this.disableButton = true;

    }
    else if (this.showSponsors == false) {
      (await this.photoService.saveSponsorData(localStorage.getItem('e'), null, null, null, this.showSponsors)).subscribe({
        next: async (res) => {
          // console.log(res); //__CONSOLE_LOG__
          let response: any;
          response = res;
          this.showMessage = response['result'];
          this.isSavingData = false;
          // let sponsor_id = response['sponsor_id'];
          // if (sponsor_id) {
          //   console.log(sponsor_id);

          //   this.deleteFolderContents(localStorage.getItem('e'), sponsor_id);

          //   for (let i = 0; i < this.selectedFiles.length; i++) {
          //     await this.uploadFile(localStorage.getItem('e'), this.selectedFiles[i], sponsor_id)
          //       .then(async (data) => {
          //         console.log("File uploaded successfully:", data);
          //         this.showMessage = "File uploaded successfully!"
          //       })
          //       .catch((error) => {
          //         console.error("Error uploading file:", error);
          //         this.showMessage = "Error uploading file!"
          //       });
          //   }
          // }
        }
      });


    }
    this.editMode = false;
    this.clearForm();
    this.closePopup();
  }

  addSponsor() {
    if (this.newSponsorName && this.newSponsorImages.length && this.newSponsorImageFrequency !== null) {
      this.sponsors.push({
        name: this.newSponsorName,
        images: [...this.newSponsorImages],
        imageFrequency: this.newSponsorImageFrequency
      });
      this.clearForm();
    }
  }


  clearForm() {
    this.newSponsorName = '';
    this.newSponsorImages = [];
    this.newSponsorImageFrequency = null;
    this.selectedFileNames = [];

  }

  // Function to delete a sponsor
  async deleteSponsor(id: any, index: number) {
    this.isSavingData = true;
    this.sponsors.splice(index, 1);
    (await this.photoService.deleteSponsorData(localStorage.getItem('e'), id)).subscribe({
      next: async (res: any) => {
        // console.log(res); //__CONSOLE_LOG__
        let response: any;
        response = res;
        this.showMessage = 'Sponsor deleted!';
        this.isSavingData = false;
        this.deleteFolderContents(localStorage.getItem('e'), id).then(response => {
          // console.log('Folder contents deleted:', response); //__CONSOLE_LOG__
        }).catch(error => {
          // console.error('Error deleting folder contents:', error); //__CONSOLE_LOG__
        });
      }
    });

  }

  // Function to edit a sponsor
  editSponsor(id: any, index: number) {
    this.editMode = true;
    this.isPopupOpen = true;
    const sponsor = this.sponsors[index];
    // console.log(sponsor) //__CONSOLE_LOG__
    this.newSponsorName = sponsor.name;
    this.newSponsorImageFrequency = sponsor.imageFrequency;
    this.newSponsorImages = [...sponsor.images];
    // console.log({ sponsor }); //__CONSOLE_LOG__
    //let files =  sponsor.fileNames.split(",").map((item: any) => item.trim());
    sponsor.fileNames.forEach((element: string) => {
      this.selectedFileNames.push(element);
    });
    this.tempData = sponsor;
    // console.log(this.selectedFileNames) //__CONSOLE_LOG__
    // Remove the sponsor from the list temporarily to allow for editing
    this.editIndex = index;
    this.sponsors.splice(index, 1);

  }


  async deleteFolderContents(eventId: any, sponsor_id: any): Promise<any> {
    const currentUser = await this.fbAuth.currentUser;
    if (!currentUser) {
      throw new Error("No authenticated user found.");
    }
    const firebaseToken = await currentUser.getIdToken(true);
    const region = 'us-west-1';
    const s3 = await createS3Client({
      region,
      credentials: await createCognitoCredentials({
        identityPoolId: this.identityPoolId,
        logins: {
          'securetoken.google.com/picaggo-235807': firebaseToken
        },
        clientConfig: { region }
      })
    });

    const { ListObjectsV2Command, DeleteObjectsCommand } = await loadS3ClientModule();

    // List all objects within the folder
    const data = await s3.send(new ListObjectsV2Command({
      Bucket: environment.aws.bucketName,
      Prefix: "photo-wall/sponsor-data/" + eventId + "/" + sponsor_id
    }));

    if (data.Contents && data.Contents.length > 0) {
      // Filter out any undefined Keys to ensure they are all strings
      const objectsToDelete = data.Contents
        .filter(item => item.Key !== undefined && !this.selectedFileNames.includes(item.Key))
        .map(item => ({ Key: item.Key! })); // Use non-null assertion
      // console.log({ objectsToDelete }); //__CONSOLE_LOG__

      if (objectsToDelete.length > 0) {
        // Delete all objects
        return await s3.send(new DeleteObjectsCommand({
          Bucket: environment.aws.bucketName,
          Delete: { Objects: objectsToDelete }
        }));
      }
      return { message: 'No objects to delete in the folder.' };
    }
    return { message: 'No objects found in the folder.' };
  }

  async uploadFile(eventId: any, file: any, sponsor_id: any): Promise<any> {
      const currentUser = await this.fbAuth.currentUser;
      if (!currentUser) {
        throw new Error("No authenticated user found.");
      }
      const firebaseToken = await currentUser.getIdToken(true);
      const region = 'us-west-1';
      const s3 = await createS3Client({
        region,
        credentials: await createCognitoCredentials({
          identityPoolId: this.identityPoolId,
          logins: {
            'securetoken.google.com/picaggo-235807': firebaseToken
          },
          clientConfig: { region }
        })
      });
    let fileName = file.name;

    const params = {
      Bucket: environment.aws.bucketName,
      Key: "photo-wall/sponsor-data/" + eventId + "/" + sponsor_id + "/" + fileName,
      Body: file,
      //Metadata: metadata
    };
    const upload = await createUpload({ client: s3, params });

    try {
      const data = await upload.done();
      // console.log("Upload complete:", data); //__CONSOLE_LOG__
      return data;
    } catch (error) {
      // console.error("Error uploading:", error); //__CONSOLE_LOG__
    }
  }


  onFileChange(event: any) {
    this.disableButton = false;
    this.selectedFiles = event.target.files as File[];

    if (event.target.files && event.target.files.length) {

      for (let file of event.target.files) {
        const updatedFileName = file.name.replace(/\s+/g, '_');
        const renamedFile = new File([file], updatedFileName, { type: file.type });

        const fileType = file.type;
        if (fileType !== 'image/png' && fileType !== 'image/jpeg' && fileType !== 'image/webp') {
          this.fileTypeError = true;
          event.target.value = ''; // Clear the input
        } else {
          this.fileTypeError = false;
          // Handle the valid file upload logic here
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.newSponsorImages.push(e.target.result);
          };
          reader.readAsDataURL(renamedFile);
          this.selectedFileNames.push(renamedFile.name);
        }

      }
    }
    // console.log(this.selectedFileNames); //__CONSOLE_LOG__
  }

  removeImage(index: number) {
    this.newSponsorImages.splice(index, 1);
    this.selectedFileNames.splice(index, 1);
  }

  onCancel() {
    this.closePopup();
    this.editMode = false;
    this.clearForm();
    this.sponsors.push(this.tempData);
  }
}
